import {Navigate, Route, Routes} from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import LobbyHome from "../features/Lobby";
import GameScreen from "../features/Game";
import React from "react";
import GameLobby from "../features/Lobby/GameLobby";
import {StompClientProvider} from "../../api/ws/StopmClientContext";
import Landing from "./Landing";
import Signup from "./Signup";
import Login from "./Login";
import {APP_INFO} from "../../config/appInfo";

function ProtectedLayout() {
    return (
        <StompClientProvider>
            <ProtectedRoute/>
        </StompClientProvider>
    );
}

function LowFiveRouter() {
    return (
        <Routes>
            <Route path="/" element={<Landing info={APP_INFO}/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/signup" element={<Signup/>}/>

            <Route element={<ProtectedLayout/>}>
                <Route path="/lobby" element={<LobbyHome/>}/>
                <Route path="/lobby/:lobbyId" element={<GameLobby/>}/>
                <Route path="/game/:gameId" element={<GameScreen/>}/>
            </Route>

            <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>

    );
}

export default LowFiveRouter;